import * as React from 'react';

import {
  UitkMessagingCard,
  UitkMessagingCardImageLayout,
  UitkMessagingCardMedia,
  UitkMessagingCardSection
} from 'uitk-react-messaging-cards';
import { UitkFigure } from 'uitk-react-images';

export interface InsightsCardProps {
  heading: string;
  icon?: string;
  subHeading: string;
}

export const InsightsCard: React.FunctionComponent<InsightsCardProps> = props => {
  const { icon, heading, subHeading } = props;

  if (!heading || !subHeading) {
    return null;
  }

  return (
    <UitkMessagingCard imageLayout={UitkMessagingCardImageLayout.LEFT}>
      {icon && (
        <UitkMessagingCardMedia>
          <UitkFigure ratio={UitkFigure.AspectRatio.R1_1} src={icon} />
        </UitkMessagingCardMedia>
      )}
      <UitkMessagingCardSection heading={heading}>
        <p className="uitk-type-300 pwa-theme--grey-700">{subHeading}</p>
      </UitkMessagingCardSection>
    </UitkMessagingCard>
  );
};
InsightsCard.displayName = 'InsightsCard';
